"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.server = void 0;
const server = (serv, { version }) => {
    serv.once('pluginsReady', () => {
        serv.onItemPlace('written_book', ({ item, player, placedPosition }) => {
            // TODO open
        });
    });
};
exports.server = server;
